// API Configuration
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:56165/api',
  timeout: 30000, // 30 seconds
  retryAttempts: 3,
  retryDelay: 1000, // 1 second
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'include' as RequestCredentials, // Include cookies
};

// Cache configuration
export const CACHE_CONFIG = {
  defaultTTL: 5 * 60 * 1000, // 5 minutes
  userProfileTTL: 10 * 60 * 1000, // 10 minutes
  staticDataTTL: 30 * 60 * 1000, // 30 minutes
};

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    sso: {
      workos: '/auth/sso/workos',
      callback: '/auth/sso/callback',
    },
    otp: {
      send: '/auth/otp/send',
      verify: '/auth/otp/verify',
    },
  },
  
  // Users
  users: {
    me: '/users/me',
    profile: '/users/profile',
    profileImage: '/users/profile/image',
    contactInfo: '/users/contact-info',
    subscription: '/users/subscription',
    cancelSubscription: '/users/subscription/cancel',
    notifications: '/users/notifications',
    paymentMethods: '/users/payment-methods',
    linkedAccounts: '/users/linked-accounts',
    linkAccount: '/users/link-account',
    inviteStats: '/users/invite-stats',
    sendInvite: '/users/send-invite',
    feedback: '/users/feedback',
  },
  
  // Providers
  providers: {
    search: '/providers/search',
    nearby: '/providers/nearby',
    detail: (id: string) => `/providers/${id}`,
    contact: (id: string) => `/providers/${id}/contact`,
    rate: (id: string) => `/providers/${id}/rate`,
    schedule: (id: string) => `/providers/${id}/schedule`,
  },
  
  // Procedures
  procedures: {
    search: '/procedures/search',
    detail: (id: string) => `/procedures/${id}`,
    pricing: (id: string) => `/procedures/${id}/pricing`,
  },
  
  // Medications
  medications: {
    search: '/medications/search',
    detail: (id: string) => `/medications/${id}`,
    pricing: (id: string) => `/medications/${id}/pricing`,
  },
  
  // Claims
  claims: {
    list: '/claims',
    summary: '/claims/summary',
    detail: (id: string) => `/claims/${id}`,
    dispute: (id: string) => `/claims/${id}/dispute`,
  },
  
  // Saved
  saved: {
    lists: '/saved/lists',
    createList: '/saved/lists',
    updateList: (id: string) => `/saved/lists/${id}`,
    deleteList: (id: string) => `/saved/lists/${id}`,
    addItem: (listId: string) => `/saved/lists/${listId}/items`,
    removeItem: (listId: string, itemId: string) => `/saved/lists/${listId}/items/${itemId}`,
    share: (listId: string) => `/saved/lists/${listId}/share`,
  },
  
  // Search
  search: {
    autocomplete: '/search/autocomplete',
    main: '/search',
    popularProcedures: '/search/popular-procedures',
    recent: '/search/recent',
    ai: {
      start: '/search/ai/start',
      followup: '/search/ai/followup',
      detail: '/search/ai/detail',
      carePlans: '/search/ai/care-plans',
    },
  },
  
  // Insurance
  insurance: {
    providers: '/insurance/providers',
    verify: '/insurance/verify',
  },
};